import React from 'react';
import classNames from 'classnames/bind';
import { RichText } from '@components';
import { Typography } from 'gd-design-library';
import { PDPShippingAndReturns } from '@services';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  shippingAndReturns: PDPShippingAndReturns;
}

export const ShippingAndReturns: React.FC<Props> = ({
  shippingAndReturns: {
    title,
    text
  }
}) => (
  <div className={ cx(productDetailsItemClassName) }>
    <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
      {title}
    </Typography>
    <RichText richText={ text } />
  </div>
);
